'use client';

import React, { useState } from 'react';
import { Alert, Box, Button, Paper, Typography } from '@mui/material';
import { useConnectedAccounts } from '@/hooks/useConnectedAccounts';

/** Phase 10 — optional bot DM test after Telegram Login connect (must /start the bot first). */
export function TelegramNotifyCard() {
  const { data: accounts, isPending } = useConnectedAccounts(true);
  const connected = Boolean(accounts?.telegram?.isConnected);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const sendTest = async () => {
    setBusy(true);
    setMessage(null);
    try {
      const r = await fetch('/api/telegram/test-notify', { method: 'POST', credentials: 'include' });
      const j = (await r.json().catch(() => ({}))) as { error?: string; detail?: string; hint?: string };
      if (!r.ok) {
        setMessage([j.error, j.detail, j.hint].filter(Boolean).join(' — ') || 'Request failed.');
        return;
      }
      setMessage('Test message sent. Check Telegram.');
    } finally {
      setBusy(false);
    }
  };

  if (isPending || !connected) return null;

  return (
    <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Telegram (bot test)
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        FloAI can send a one-off test DM using the same bot as Login Widget. Open your bot in Telegram and send{' '}
        <strong>/start</strong> first, or Telegram may block the message.
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
        <Button type="button" variant="outlined" onClick={() => void sendTest()} disabled={busy}>
          {busy ? 'Sending…' : 'Send test DM'}
        </Button>
      </Box>
      {message ? (
        <Alert severity={message.includes('sent') ? 'success' : 'error'} sx={{ mt: 2 }}>
          {message}
        </Alert>
      ) : null}
    </Paper>
  );
}
